/**
 * Adjust Height to target element's height
 * Used to fix layout problems with absolute elements
 *
 * @param  element          el          Dom element to adjust the height
 * @param  string           target      Query Selector to target one element to get height from
 * @param  string           attr        Attribute on the source to modify
 * @param  string           attrTarget  Attribute on the target to get value from
 * @param  int              multiplier  Multiply to allow reversing the value or other manipulations
 * @return void
 */
function adjustCssToTarget(el, target, attr, attrTarget, mode, multiplier) {
    const _this = $(el);
    const target_element = $(target);

    if (target_element.length > 0) {
        const cssValue = target_element.first().css(attrTarget);
        const rectValue = target_element.first()[0].getBoundingClientRect()[attrTarget];
        const elValue = target_element.first()[0][attrTarget];
        let value = parseFloat(cssValue);

        if (mode == 'rect') {
            value = parseFloat(rectValue);
        } else if (mode == 'el') {
            value = parseFloat(elValue);
        }

        if (typeof multiplier === 'number') {
            value *= multiplier;
        }

        _this.css(attr, value);
        _this.addClass('css-target-adjusted');
    }
}
function adjustCssToTargetHandler(ev) {
    $('[data-css-target]').each(function(index, el) {
        adjustCssToTarget(
            el,
            $(this).data('css-target'),
            $(this).data('css-attr'),
            $(this).data('css-target-attr'),
            $(this).data('css-target-mode'),
            $(this).data('css-multiplier'),
        );
    });
}

function debounce(func) {
    var wait = arguments.length <= 1 || arguments[1] === undefined ? 500 : arguments[1];

    var timeout = void 0;
    return function () {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(_this, args);
        }, wait);
    };
}

/**
 * Simple cross-browser url parser
 */
function parseURL ( url ) {
    var a = document.createElement('a');
    a.href = url;
    return a;
}




/**
 * Parse Query string
 * @param  String queryString   URL formatted query string with or without first param
 * @return Object               Return the object of params
 */
function parseQueryString( queryString ) {
    var params = {}, queries, temp, i, l;
    queryString = queryString.slice(1);
    queries = queryString.split("&");

    for ( i = 0, l = queries.length; i < l; i++ ) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
    }

    return params;
}
function createQueryString( params ) {
    return '?' + Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

export { adjustCssToTarget, adjustCssToTargetHandler, debounce, parseQueryString, createQueryString, parseURL }